var map = {
	"./BlockContextMenu.vue": 7241,
	"./BlockUsageWarningModal.vue": 2647,
	"./Canvas.vue": 8768,
	"./DocumentIframe.js": 4430,
	"./Gallery.vue": 4706,
	"./ModeAndViewportToolbar.vue": 7443,
	"./ToolbarTop.vue": 8278,
	"./VersionActions.vue": 4405,
	"./resizableMargin.js": 6672,
	"./tooltip.js": 2656
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 571;